import { useEffect, useState } from 'react';
import { Gift } from 'lucide-react';

const BARVA = '#22C55E';

/**
 * Ingredience v ceně (2026-10-23) — pizza dle vlastní stavby: 4 přidané
 * ingredience podle výběru v ceně, další za běžnou cenu přídavku.
 *
 * Platí pro všechny přidané ingredience položky (odebrání se nepočítá).
 * Skupina ingrediencí může mít vlastní „v ceně" — ta se odečte dřív.
 * V ceně jsou vždy nejdražší vybrané. Nastavuje se na kategorii, dědí se
 * a produkt to může přebít. `value` null = podle nadřazené úrovně.
 */
export default function PridavkyVCene({ value, zdedeno = 0, nazevZdedeni = 'Podle kategorie', onChange, isDark }) {
    const muted = isDark ? 'rgba(255,255,255,0.4)' : 'var(--text-muted)';
    const border = isDark ? 'rgba(255,255,255,0.08)' : 'var(--border-default)';
    const [text, setText] = useState(value == null ? '' : String(value));
    useEffect(() => { setText(value == null ? '' : String(value)); }, [value]);

    const ulozit = () => {
        const t = text.trim();
        const v = t === '' ? null : Math.min(20, Math.max(0, parseInt(t, 10) || 0));
        if (v !== (value ?? null)) onChange(v);
        else setText(value == null ? '' : String(value));
    };

    return (
        <div className="rounded-xl px-4 py-3" style={{
            background: isDark ? 'rgba(255,255,255,0.03)' : 'var(--surface-base)',
            border: `1px solid ${border}`,
        }}>
            <div className="text-sm font-semibold mb-1" style={{ color: 'var(--text-primary)' }}>Ingredience v ceně</div>
            <p className="text-[11px] mb-2" style={{ color: muted }}>
                Kolik přidaných ingrediencí si host vybere v ceně (třeba pizza dle vlastní stavby: 4). Další se platí
                běžnou cenou přídavku, v ceně jsou ty nejdražší. Skupina ingrediencí může mít vlastní počet, ten se odečte dřív.
            </p>
            <div className="flex flex-wrap items-center gap-2">
                <input type="text" inputMode="numeric" value={text}
                    onChange={e => setText(e.target.value.replace(/[^0-9]/g, '').slice(0, 2))}
                    onBlur={ulozit}
                    onKeyDown={e => e.key === 'Enter' && e.currentTarget.blur()}
                    onFocus={e => e.target.select()}
                    placeholder={String(zdedeno)}
                    aria-label="Ingredience v ceně"
                    className="rounded-lg text-center text-sm font-bold"
                    style={{ width: 56, height: 32, border: `1px solid ${value != null ? BARVA : border}`, background: 'transparent', color: 'var(--text-primary)' }} />
                <span className="text-xs" style={{ color: 'var(--text-secondary)' }}>ks</span>
                {value == null ? (
                    <span className="flex items-center gap-1 text-[11px]" style={{ color: muted }}>
                        <Gift size={12} /> {nazevZdedeni}: {zdedeno || 'žádné'}
                    </span>
                ) : (
                    <button type="button" onClick={() => onChange(null)} className="text-[11px] font-semibold"
                        style={{ background: 'none', border: 'none', color: muted, cursor: 'pointer', minHeight: 30 }}>
                        {nazevZdedeni} ({zdedeno || 'žádné'})
                    </button>
                )}
            </div>
        </div>
    );
}
